import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

// Custom Components
import ModelTable from "@/ui/Table/ModelTable";

//Types
import { Box } from "@mui/material";


const ObjectAnalysisBuildingsTable: FunctionComponent<React.PropsWithChildren<any>> = (props) => {
  const { t } = useTranslation();
  const { records, dc, onSelectBuilding } = props;

  return (
    <Box height={"230px"}>
      <ModelTable
        title={t("titles.zgrade")}
        records={records}
        viewName="default"
        dc={dc}
        allowSelection="one"
        onRowClick={onSelectBuilding}
        allowSearchBar={false}
        allowFilter={false}
        allowExport={false}
        allowColumnPicker={false}
        allowEdit={false}
        allowInlineEdit={false}
        allowInlineEditQuickly={false}
        allowInc={false}   
        disableControls={true}   
        showControlSwitch={false}
        initialPageSize={25}
        allowRowAction={() => { return false; }}
        trackTableState={false}
        unselectRow={true}
        customRecordCount={records.length}
        gotoFirstPageOnSelect={false}
        onRowAction={()=>{}}
        displayHeader={false}
      />
    </Box>
  );
}

export default ObjectAnalysisBuildingsTable;
